import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ListaEliminarCuenta() {
  const user = JSON.parse(localStorage.getItem("user"));
        const location = useLocation();
        const navigate = useNavigate();
        
          const cobrador = location.state?.cobrador || null;


  const [busqueda, setBusqueda] = useState("");
  const [menuAbierto, setMenuAbierto] = useState(false);

  const [clientesOpen, setClientesOpen] = useState(false);
  const [listasOpen, setListasOpen] = useState(false);
  const [informacionOpen, setInformacionOpen] = useState(false);
  const [notasOpen, setNotasOpen] = useState(false);


useEffect(() => {
  const ruta = location.pathname;

  // CLIENTES
  if (
    ruta === "/listaclientes" ||
    ruta === "/listacuentas" ||
    ruta === "/listadesactivados" ||
    ruta === "/listaeliminarcliente" ||
    ruta === "/listaeliminarcuenta"
  ) {
    setClientesOpen(true);
  }

  // LISTAS PERSONALIZADAS
  if (ruta === "/listaspersonalizadas") {
    setListasOpen(true);
  }

  // INFORMACION COBRO
  if (
    ruta === "/reportediario" ||
    ruta === "/ultimolugarregistrado" ||
    ruta === "/posicionclientes" ||
    ruta === "/enviarmensaje"
  ) {
    setInformacionOpen(true);
  }

  // NOTAS
  if (
    ruta === "/notascobro" ||
    ruta === "/notascobrosocio"
  ) {
    setNotasOpen(true);
  }

}, [location.pathname]);

 

 const th = {
  padding: "8px 10px",
  whiteSpace: "nowrap",
  textAlign: "left",
};
const td = {
  padding: "6px 10px",
  borderBottom: "1px solid #eee",
  whiteSpace: "nowrap",
};



  return (
   <div style={{ padding: 10 }}>
             {/* NAV SUPERIOR RESPONSIVE */}
<div
  style={{
    width: "100%",
    maxWidth: "100%",
    background: "#0740A0",
    color: "white",
    padding: "12px 16px",
    borderRadius: "8px",
    marginBottom: "20px",
    boxSizing: "border-box",
    overflow: "hidden",
    wordWrap: "break-word",
  }}
>
  <h2
    style={{
      margin: 0,
      fontSize: "clamp(16px, 4vw, 20px)", // Se ajusta según pantalla
      fontWeight: "bold",
      lineHeight: 1.2,
    }}
  >
     
         Supervisando a  {cobrador.persona?.nombre || cobrador.info_usuario.usuario}
  </h2>
  <h2
    style={{
      margin: 0,
      fontSize: "clamp(16px, 4vw, 20px)", // Se ajusta según pantalla
      fontWeight: "bold",
      lineHeight: 1.2,
    }}
  >
    
      {/* BOTÓN MENU */}
      <button
        onClick={() => setMenuAbierto(true)}
        style={{
          fontSize: 25,
          padding: 8,
          border: "none",
           background: "#0740A0",
    color: "white",
          cursor: "pointer",
        }}
      >
        ☰
      </button>
          {user.persona_nombre || user.usuario} 
  </h2>
  <p
    style={{
      margin: "4px 0 0 0",
      fontSize: "clamp(12px, 3vw, 15px)", // También responsivo
      opacity: 0.95,
      lineHeight: 1.2,
    }}
  >
    
  </p>
</div>
      {/* MENU LATERAL */}
      {menuAbierto && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            background: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(2px)",
            zIndex: 999,
          }}
          onClick={() => setMenuAbierto(false)}
        >
          <div
            style={{
              width: 250,
              height: "100%",
              background: "white",
              padding: 20,
              boxShadow: "3px 0 10px rgba(0,0,0,0.3)",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ marginTop: 0 }}>Menú</h2>

      {/* CLIENTES */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setClientesOpen(!clientesOpen)}
>
  👥 Clientes {clientesOpen ? "🔼" : "🔽"}
</p>

{clientesOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }}  onClick={() => navigate("/listaclientes", { state: { cobrador } })}>
      📋 Listado de clientes
    </p>
    <p  style={{ cursor: "pointer" }}   onClick={() => navigate("/listacuentas", { state: { cobrador } })}>
      💳 Listado de cuentas
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listadesactivados", { state: { cobrador } })}>
      ⛔ Clientes desactivados
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listaeliminarcliente", { state: { cobrador } })}>
      ✅ Aprobar eliminación de cliente
    </p>
    <p style={{
    cursor: "pointer",
    backgroundColor: "#0740A0", // azul
    color: "#ffffff",
    padding: "8px 12px",
    borderRadius: "10px",
    width: "fit-content",
    margin: "6px 0"
  }}>
      🗑️ Aprobar eliminación de cuenta
    </p>
  </div>
)}

{/* LISTAS PERSONALIZADAS */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setListasOpen(!listasOpen)}
>
  🗂️ Listas personalizadas {listasOpen ? "🔼" : "🔽"}
</p>

{listasOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/listaspersonalizadas", { state: { cobrador } })}>
      📑 Ver listas personalizadas
    </p>
  </div>
)}

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/filtroclientes", { state: { cobrador } })}>
  🔍 Filtros de clientes
</p>

{/* INFORMACIÓN COBRO */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setInformacionOpen(!informacionOpen)}
>
  💰 Información de cobro {informacionOpen ? "🔼" : "🔽"}
</p>

{informacionOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p  style={{ cursor: "pointer" }} onClick={() => navigate("/reportediario", { state: { cobrador } })}>
      📊 Reporte diario
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/ultimolugarregistrado", { state: { cobrador } })}>
      📍 Último lugar registrado
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/posicionclientes", { state: { cobrador } })}>
      🧭 Posición de clientes
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/enviarmensaje", { state: { cobrador } })}>
      ✉️ Enviar mensaje
    </p>
  </div>
)}

{/* NOTAS */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setNotasOpen(!notasOpen)}
>
  📝 Notas {notasOpen ? "🔼" : "🔽"}
</p>

{notasOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/notascobro", { state: { cobrador } })}>
      🗒️ Notas de cobro
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/notascobrosocio", { state: { cobrador } })}>
      🤝 Notas de cobro socio
    </p>
  </div>
)}

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/nuevaliquidacion", { state: { cobrador } })}>
  💵 Nueva liquidación
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/listaliquidadas", { state: { cobrador } })}>
  📃 Lista de liquidadas
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/solicitudmodificarcliente", { state: { cobrador } })}>
  ✏️ Solicitud modificar cliente
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/solicitudgastos", { state: { cobrador } })}>
  🧾 Solicitud de gastos
</p>

       <p style={{ cursor: "pointer", fontWeight: "bold" ,color:"white"}}>
             final menu
              </p>
          </div>
        </div>
      )}

   {/* 🔍 BUSCADOR (NO SE SALE DE LA PANTALLA) */}
      <input
        type="text"
        placeholder="Buscar cliente..."
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        style={{
          width: "100%",
          maxWidth: "100%",
          padding: 8,
          fontSize: 15,
          borderRadius: 5,
          border: "1px solid #ccc",
          marginBottom: 12,
          boxSizing: "border-box",
        }}
      />
  
           {/* TABLA SCROLLEABLE SOLO HASTA EL ANCHO REAL */}
      <div
        style={{
          overflowX: "auto",
          borderRadius: 6,
          border: "1px solid #ddd",
          paddingBottom: 5,
        }}
      >
      {/* TABLA */}
    <div
  style={{
    maxHeight: "65vh",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: 8,
  }}
>
  <table
    style={{
      width: "100%",
      minWidth: "900px",
      borderCollapse: "collapse",
      background: "white",
    }}
  >
    <thead
      style={{
        position: "sticky",
        top: 0,
        background: "#0740A0",
        color: "white",
        zIndex: 2,
      }}
    >
            <tr>
              <th style={th}>Cedula</th>
              <th style={th}>Nombre</th>
              <th style={th}>Apellido</th>
              <th style={th}>Negocio</th>
              <th style={th}>Telefono</th>
              <th style={th}></th>

            
              <th style={th}></th>
            </tr>
          </thead>

       <tbody>
  <tr>
    <td style={td}>5124512</td>
    <td style={td}>Martin</td>
    <td style={td}>Gutierrez</td>
    <td style={td}>Venta de repuestos de celulares</td>
    <td style={td}>72914512</td>
     <td style={td}></td>


  </tr>
</tbody>

        </table>
      </div>
 </div>
</div>
  );
}
